import React from 'react'
import { ServerConfig } from 'config'

import NonPaginatedList from '../../components/EntryListAndEdit/NonPaginatedList'


const TenantSites = () => {
  const non_editable_fields = [
    ["id", "id", ""],
    //["owner", "Owner", ""]
  ];

  const editable_fields = [
    ["owner", "Owner", "tenant"],
    ["name", "Name"],
    ["street", "Street"],
    ["zip", "ZipCode"],
    ["city", "City"],
    ["state", "State"],
    ['phone_number', 'Phone Number', "phone_number"],
    ['contact_email', 'Contact Email'],
    ['tzid', 'Timezone', 'tzid'],
    ['latitude', 'Latitude'],
    ['longitude', 'Longitude'],
    ['hours', 'Hours', "hours"],
  ];

  return (
    <>
      <NonPaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/admin/tenant_sites`}
        detail_get_url={`${ServerConfig.SERVER_URL}/admin/tenant_sites/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/admin/tenant_sites/`}
        detail_delete_url={`${ServerConfig.SERVER_URL}/admin/tenant_sites/`}
        detail_delete_method="delete"
        add_new_url = {`${ServerConfig.SERVER_URL}/admin/tenant_sites/`}

        column_names={["id", "name", "edit"]}
        header_names={["id", "name", ""]}

        optional_column_names={["street", "zip", "city", "state", 'services', 'contact_email']}
        optional_header_names={["Street", "Zip", "City", "State", 'Services', 'Contact Email']}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}
        //ledger_get_url = '/ledger/customer/'
        //show_machine_stats={true}
      />
    </>
  )
}

export default TenantSites
